import { Box, Heading, Text } from "@origin-digital/ods-core";
import React from "react";
import { DescriptionSkeleton } from "./DescriptionSkeleton";

interface DescriptionProps {
  description: string;
  title: string;
  isLoading?: boolean;
}

export const Description: React.FC<DescriptionProps> = ({
  description,
  title,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <Box width="full">
        <DescriptionSkeleton />
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap="small">
      <Heading component="h2" variant="h2">
        {title}
      </Heading>
      <Box>
        <Text variant="body" tone="neutralDark">
          {description}
        </Text>
      </Box>
    </Box>
  );
};
